/**
 * Mise en forme du double facteur (AB#296) — fonctions pures, testées sans DOM.
 */

/**
 * Clé TOTP (base32) lisible à la main : groupes de quatre, séparés par une
 * espace. Les applications d'authentification ignorent les espaces à la
 * saisie ; l'œil, lui, ne recopie pas trente-deux caractères d'un trait.
 */
export function grouperSecretTotp(secret: string): string {
  return (
    secret
      .replace(/\s+/g, '')
      .toUpperCase()
      .match(/.{1,4}/g)
      ?.join(' ') ?? ''
  );
}
